import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import ProjectDetail from "./pages/ProjectDetail";
import ProjectDatabases from "./pages/ProjectDatabases";
import CallSheetBuilder from "./pages/CallSheetBuilder";
import CallSheetPreview from "./pages/CallSheetPreview";
import CallSheetPrintView from "./pages/CallSheetPrintView";
import DistributeCallSheet from "./pages/DistributeCallSheet";
import PublicCallSheet from "./pages/PublicCallSheet";
import CrewManagement from "./pages/CrewManagement";
import LocationsManagement from "./pages/LocationsManagement";
import Settings from "./pages/Settings";
import InvitationAccept from "./pages/InvitationAccept";
import BillingPage from "./pages/BillingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/invitations/:token" element={<InvitationAccept />} />
          <Route path="/billing/success" element={<PaymentSuccess />} />
          <Route path="/billing/cancel" element={<PaymentCancel />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          {/* Print-only route consumed by the backend Playwright printer.
              Auth is handled via a short-lived print_token query param, so
              this route must sit outside ProtectedRoute. */}
          <Route path="/callsheets/:callsheetId/print" element={<CallSheetPrintView />} />
          <Route path="/callsheets/:callsheetId/distribute" element={<DistributeCallSheet />} />
          {/* Public shareable preview — no login required. */}
          <Route path="/p/:token" element={<PublicCallSheet />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/projects/:projectId" element={<ProjectDetail />} />
            {/* Split per-project databases. The legacy /databases route is
                kept for backward-compat but immediately redirects to /crew. */}
            <Route path="/projects/:projectId/databases" element={<Navigate to="crew" replace />} />
            <Route path="/projects/:projectId/crew" element={<ProjectDatabases view="crew" />} />
            <Route path="/projects/:projectId/talent" element={<ProjectDatabases view="talent" />} />
            <Route path="/projects/:projectId/locations" element={<ProjectDatabases view="locations" />} />
            <Route path="/projects/:projectId/callsheets/new" element={<CallSheetBuilder />} />
            <Route path="/callsheets/:callsheetId/edit" element={<CallSheetBuilder />} />
            <Route path="/callsheets/:callsheetId/preview" element={<CallSheetPreview />} />
            <Route path="/crew" element={<CrewManagement />} />
            <Route path="/locations" element={<LocationsManagement />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/billing" element={<BillingPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
